import React from "react";

import { ConfirmPopUp } from "../ConfirmPopUp";
import { DeletePopUpProps } from "./types";

/**
 * Destructive confirmation preset over {@link ConfirmPopUp}: danger tone with
 * delete-flavoured default labels. Use ConfirmPopUp directly for
 * non-destructive confirmations (status changes, edit warnings).
 */
export const DeletePopUp: React.FC<DeletePopUpProps> = ({
  handleOnDelete,
  tone = "danger",
  confirmLabel = "Delete",
  loadingLabel = "Deleting…",
  ...rest
}) => (
  <ConfirmPopUp
    onConfirm={handleOnDelete}
    tone={tone}
    confirmLabel={confirmLabel}
    loadingLabel={loadingLabel}
    {...rest}
  />
);
